const RELOAD_TIMESTAMP_KEY = "chunk-reload-timestamp";
const DEFAULT_COOLDOWN_MS = 60_000;

// Reloads the current page. Indirection through this module lets tests assert
// the reload was triggered without needing to redefine the read-only
// window.location.reload property in jsdom.
export function reloadPage(): void {
  window.location.reload();
}

// Records a reload attempt and returns true if a reload should proceed.
// Prevents tight reload loops when a chunk load error is reproducible (e.g.
// the deployed bundle itself has a runtime error), while still allowing the
// recovery path to fire again later in the session if a *new* deploy lands.
export function shouldAttemptChunkReload(cooldownMs = DEFAULT_COOLDOWN_MS): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  // sessionStorage access can throw SecurityError in restricted contexts
  // (sandboxed iframes, certain privacy modes). Any throw from here would
  // escape componentDidCatch and bypass the Studio recovery UI, so we treat
  // storage failure as "first attempt" and let the reload proceed unguarded.
  try {
    const last = Number(sessionStorage.getItem(RELOAD_TIMESTAMP_KEY) ?? 0);
    if (Number.isFinite(last) && Date.now() - last < cooldownMs) {
      return false;
    }
    sessionStorage.setItem(RELOAD_TIMESTAMP_KEY, String(Date.now()));
  } catch {
    // fall through and allow the reload
  }
  return true;
}
